/** @owner @Appboy/ai-decisioning-experience */

import type { DecisioningStudioCampaignContext } from "./types";

/**
 * @param messagesContext - The current messages context, if any
 * @return Whether the composer should expose decisioning creative component personalization
 */
export const isDecisioningStudioCampaign = (
  messagesContext: DecisioningStudioCampaignContext | null | undefined
): boolean => {
  if (!messagesContext) {
    return false;
  }
  if (messagesContext.type !== "campaign") {
    return false;
  }
  if (!messagesContext.decisioningStudioAgentId) {
    return false;
  }
  return true;
};
